import controller from './doctor-appointments-card.controller';
import template from './doctor-appointments-card.html';

const doctorAppointmentsCardComponent = {
	bindings: {
		doctor: '<',
		isSponsored: '<',
		horary: '<',
		firstDay: '<',
		secondDay: '<',
		thirdDay: '<',
		class: '<',
		language: '<'
	},
	controller,
	template,
};

export default doctorAppointmentsCardComponent;


// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/app/components/doctor-appointments-card/doctor-appointments-card.component.js